import React from 'react';
import { PlanLoaderProgressV3 } from '../PlanLoaderProgressV3';

const DELAY = 800;

function PlanLoaderSlideV3({
    onContinue,
    planTitle = 'Personal Protection Plan',
    steps = ['Assessing your risks', 'Detecting vulnerabilities', 'Preparing personalized tools and tips'],
    usersCount,
    hasRiskBadges = true,
    questions
}) {
    const finishProgress = () => {
        setTimeout(() => {
            onContinue();
        }, DELAY);
    };

    return (
        <PlanLoaderProgressV3
            finish={finishProgress}
            planTitle={planTitle}
            steps={steps}
            usersCount={usersCount}
            hasRiskBadges={hasRiskBadges}
            questions={questions}
        />
    );
}

export {
    PlanLoaderSlideV3
};
